import React, { useState, useEffect } from "react";
import axios from "axios";

import { Container, Typography, Box } from "@mui/material";
import { Grid, Card, CardContent } from "@mui/material";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import ScrollTopButton from "../../components/ScrollTopButton";
const Showmedia = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3001/api/";
  } else {
    xURL = "https://sau.rihes.cmu.ac.th/api/";
  }

  const [zhead, _zhead] = useState("");
  const [zorder, _zorder] = useState("");

  var url = new URL(window.location.href);

  const [videoList, _videoList] = useState([""]);

  // const videoList = [
  //   {
  //     title: "สมองติดยา",
  //     url: "https://www.youtube.com/embed/tqlx0aJjOs8"
  //   },
  //   {
  //     title: "ผลกระทบยาเสพติดต่อร่างกาย",
  //     url: "https://www.youtube.com/embed/Fzq0RG3jizM"
  //   },
  //   {
  //     title: "จะเกิดอะไรขึ้นเมื่อเหล้าเข้าปาก",
  //     url: "https://www.youtube.com/embed/7QYbIkVsPuw"
  //   },
  //   {
  //     title: "เหล้าแก้หนาวจริงหรือ",
  //     url: "https://www.youtube.com/embed/2iX7LYMES5k"
  //   },
  //   {
  //     title: "จะเกิดอะไรขึ้นเมื่อเยาวชนเสพกัญชา",
  //     url: "https://www.youtube.com/embed/8N3X6xk8TCA"
  //   }
  // ];

  useEffect(() => {
    Find_media();
  }, []);

  const Find_media = () => {
    axios
      .get(xURL + "find_media")
      .then(result => {
        Showmedia(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Showmedia = zdata => {
    const Tb1 = [];

    zdata.forEach((i, idx) => {
      Tb1.push({
        title: i.name,
        url: "https://www.youtube-nocookie.com/embed/" + i.remark
      });
    });

    _videoList(Tb1);
  };

  return (
    <React.Fragment>
      <Navbar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh" // ทำให้สูงเท่าหน้าจอ
        }}
      >
        <Container sx={{ textAlign: "center", maxWidth: "md" }}>
          <Typography
            gutterBottom
            sx={{
              mt: 18,
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              textAlign: "center",
              background: "linear-gradient(90deg, #3F51B5, #00BCD4)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
              textShadow: "1px 1px 2px rgba(0,0,0,0.08)",
              letterSpacing: "0.8px",
              lineHeight: 1.4
            }}
          >
            คลิป
          </Typography>

          <Box sx={{ maxWidth: 1200, mx: "auto", mt: 4, px: 2 }}>
            <Grid container spacing={4}>
              {videoList.map((video, index) =>
                <Grid item xs={12} sm={6} md={6} key={index}>
                  <Card
                    sx={{
                      borderRadius: 3,
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                      background:
                        "linear-gradient(135deg, rgba(255,255,255,0.7), rgba(230,240,255,0.6))",
                      backdropFilter: "blur(10px)",
                      width: "350px",
                      height: "100%"
                    }}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        paddingTop: "56.25%" /* 16:9 */
                      }}
                    >
                      <iframe
                        src={video.url}
                        title={video.title}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          border: 0,
                          borderRadius: "8px"
                        }}
                        referrerPolicy="strict-origin-when-cross-origin"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                    </Box>

                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                          fontFamily: "Poppins, sans-serif",
                          textAlign: "center"
                        }}
                      >
                        {video.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          </Box>
        </Container>

        <ScrollTopButton />
      </Box>

      <Footer />
    </React.Fragment>
  );
};

export default Showmedia;
